var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_3878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_3878)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_50_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4121 47.7969C17.3657 54.7626 23.5481 62.5562 31.2363 62.6084C38.9273 62.6607 45.2139 54.9543 45.2603 47.9857C45.3066 41.02 39.0982 37.4297 31.4071 37.3774C23.7161 37.3251 17.4584 40.8283 17.4092 47.794L17.4121 47.7969Z",
    fill: "url(#paint0_linear_50_3878)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.3512 40.8716L41.3486 40.8729C39.9032 41.5961 39.3159 43.3578 40.0369 44.8078L43.59 51.9534C44.311 53.4034 46.0672 53.9925 47.5126 53.2693L47.5152 53.268C48.9606 52.5447 49.5479 50.783 48.827 49.3331L45.2738 42.1874C44.5528 40.7374 42.7966 40.1483 41.3512 40.8716Z",
    fill: "url(#paint1_linear_50_3878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7935 36.6489L11.7911 36.6505C10.4454 37.5467 10.0787 39.3676 10.9721 40.7175L16.5314 49.1174C17.4248 50.4673 19.2399 50.8351 20.5856 49.9389L20.588 49.9373C21.9337 49.0411 22.3004 47.2203 21.407 45.8704L15.8477 37.4705C14.9543 36.1205 13.1392 35.7527 11.7935 36.6489Z",
    fill: "url(#paint2_linear_50_3878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0441 27.3544L-0.368372 33.0519C-0.713974 33.2244 -0.854272 33.6445 -0.681734 33.9901L6.2283 47.8313C6.40084 48.1769 6.82087 48.3172 7.16647 48.1447L18.5789 42.4472C18.9245 42.2746 19.0648 41.8546 18.8923 41.509L11.9823 27.6678C11.8097 27.3222 11.3897 27.1819 11.0441 27.3544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1223 35.8977L4.60336 40.6498C4.41036 40.7462 4.33202 40.9807 4.42837 41.1737C4.52472 41.3667 4.75928 41.4451 4.95228 41.3487L14.4712 36.5966C14.6642 36.5002 14.7425 36.2656 14.6462 36.0726C14.5498 35.8796 14.3153 35.8013 14.1223 35.8977Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3351 34.3615L3.81625 39.1136C3.62325 39.21 3.54491 39.4445 3.64126 39.6375C3.73761 39.8305 3.97217 39.9089 4.16517 39.8125L13.6841 35.0604C13.8771 34.964 13.9554 34.7295 13.8591 34.5365C13.7627 34.3435 13.5281 34.2651 13.3351 34.3615Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.249 31.6717L4.12094 34.2318C3.92794 34.3281 3.84959 34.5627 3.94595 34.7557C4.0423 34.9487 4.27686 35.0271 4.46986 34.9307L9.59792 32.3706C9.79092 32.2742 9.86926 32.0397 9.77291 31.8467C9.67656 31.6537 9.442 31.5753 9.249 31.6717Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8771 37.4508L5.35824 42.2029C5.16525 42.2993 5.0869 42.5339 5.18325 42.7269C5.2796 42.9198 5.51417 42.9982 5.70717 42.9018L15.2261 38.1497C15.4191 38.0533 15.4974 37.8188 15.4011 37.6258C15.3047 37.4328 15.0701 37.3544 14.8771 37.4508Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.633 38.9659L6.1141 43.718C5.9211 43.8144 5.84276 44.049 5.93911 44.2419C6.03546 44.4349 6.27003 44.5133 6.46302 44.4169L15.9819 39.6648C16.1749 39.5684 16.2533 39.3339 16.1569 39.1409C16.0606 38.9479 15.826 38.8695 15.633 38.9659Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3898 40.481L6.87094 45.2331C6.67794 45.3295 6.59959 45.5641 6.69594 45.7571C6.7923 45.9501 7.02686 46.0284 7.21986 45.9321L16.7388 41.1799C16.9318 41.0835 17.0101 40.849 16.9137 40.656C16.8174 40.463 16.5828 40.3846 16.3898 40.481Z",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2442 19.8151L17.6024 16.98C16.1835 16.1114 14.3997 16.1056 12.975 16.9655C10.5686 18.412 8.75881 20.6749 7.87272 23.3444C6.40169 27.7684 8.37079 32.6048 12.5059 34.7312L17.1043 37.0957L22.2413 19.8151H22.2442Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3721 22.4381L17.5121 20.0823C16.3306 19.3619 14.848 19.3561 13.6636 20.0707C11.6656 21.2733 10.1598 23.1556 9.4243 25.3719C8.2023 29.0494 9.83839 33.0696 13.2785 34.8386L17.1009 36.8052L21.3721 22.4381Z",
    fill: "url(#paint3_linear_50_3878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3721 19.8151L43.0139 16.98C44.4328 16.1114 46.2166 16.1056 47.6413 16.9655C50.0447 18.412 51.8546 20.6749 52.7407 23.3415C54.2117 27.7655 52.2426 32.6019 48.1075 34.7282L43.5091 37.0927L38.3721 19.8121V19.8151Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2432 22.4381L43.1032 20.0823C44.2846 19.3619 45.7672 19.3561 46.9516 20.0707C48.9496 21.2733 50.4554 23.1556 51.1909 25.3719C52.4129 29.0494 50.7768 33.0696 47.3367 34.8386L43.5144 36.8052L39.2432 22.4381Z",
    fill: "url(#paint4_linear_50_3878)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_50_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8016 33.546C45.8016 42.1297 38.8664 45.9785 30.3095 45.9785C21.7526 45.9785 14.8174 42.1297 14.8174 33.546C14.8174 24.9623 24.3675 15.7454 30.3095 15.7454C36.2515 15.7454 45.8016 24.9623 45.8016 33.546Z",
    fill: "url(#paint5_linear_50_3878)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_50_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0112 16.8522C28.378 17.9037 28.4012 20.9654 28.4012 20.9654C28.433 21.0699 28.5807 21.0351 28.6299 21.0031C28.8413 20.8666 29.3278 20.2711 29.3278 20.2711C29.3886 20.184 29.5189 20.2043 29.5537 20.3031C29.5537 20.3031 29.8751 21.4127 29.9475 22.409C29.9533 22.4729 30.1444 22.4381 30.1936 22.4032C30.654 22.0692 31.0421 20.2362 31.0421 20.2362C31.071 20.1346 31.1984 20.1084 31.265 20.1869C31.265 20.1869 31.7863 20.4251 32.0585 21.1396C32.0787 21.1948 32.2409 21.1222 32.2843 21.0815C33.1502 20.2856 33.6772 17.2705 33.0285 16.3322C32.1077 14.9989 25.7429 15.8733 27.0112 16.8493V16.8522Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0907 30.593C36.7496 29.2477 34.5792 29.2477 33.2381 30.593C33.0594 30.7723 32.7691 30.7728 32.5898 30.594C32.4106 30.4153 32.4101 30.1251 32.5888 29.9458C34.2882 28.2411 37.0406 28.2411 38.74 29.9458C38.9187 30.1251 38.9183 30.4153 38.739 30.594C38.5597 30.7728 38.2694 30.7723 38.0907 30.593Z",
    fill: "#474193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3409 35.4806C26.8198 35.4806 28.8293 32.8796 28.8293 29.671C28.8293 26.4625 26.8198 23.8614 24.3409 23.8614C21.8621 23.8614 19.8525 26.4625 19.8525 29.671C19.8525 32.8796 21.8621 35.4806 24.3409 35.4806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5267 29.2179C27.5267 28.0949 26.6191 27.1845 25.4997 27.1845C24.3802 27.1845 23.4727 28.0949 23.4727 29.2179V31.2512C23.4727 32.3742 24.3802 33.2846 25.4997 33.2846C26.6191 33.2846 27.5267 32.3742 27.5267 31.2512V29.2179Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0653 30.0893C25.625 30.0893 26.0788 29.6341 26.0788 29.0726C26.0788 28.5111 25.625 28.0559 25.0653 28.0559C24.5055 28.0559 24.0518 28.5111 24.0518 29.0726C24.0518 29.6341 24.5055 30.0893 25.0653 30.0893Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_50_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 39.2597L15.5607 38.6061C15.8242 38.1123 16.4729 37.9206 16.9246 38.2518C16.9565 38.275 17.8628 39.9627 18.526 40.4681C19.2557 41.0229 20.7006 41.0897 21.9719 39.8668C23.6572 38.2459 23.8599 35.6955 25.0124 34.676C27.0365 32.8837 29.4776 33.18 31.1687 34.6527C32.8598 36.1254 33.2073 38.856 32.0084 40.7702C30.8154 42.6787 26.5963 44.9444 24.4448 45.5602C21.8039 46.3155 19.1717 45.0983 18.0163 44.2095C16.1688 42.7948 14.9439 40.6163 14.9439 40.6163C14.4285 40.1108 14.7789 39.5676 15.2161 39.2597H15.2133Z",
    fill: "url(#paint6_linear_50_3878)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1122 36.3565C40.3648 36.3735 40.5559 36.592 40.5389 36.8446C40.3483 39.6843 37.8952 41.8344 35.0613 41.6429C34.8087 41.6259 34.6178 41.4073 34.6348 41.1547C34.6519 40.9021 34.8705 40.7112 35.1231 40.7282C37.4494 40.8854 39.4673 39.1198 39.6242 36.7832C39.6411 36.5306 39.8596 36.3396 40.1122 36.3565Z",
    fill: "#806CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5455 35.3019C26.6467 35.3019 29.1608 32.7879 29.1608 29.6866C29.1608 26.5853 26.6467 24.0713 23.5455 24.0713C20.4442 24.0713 17.9302 26.5853 17.9302 29.6866C17.9302 32.7879 20.4442 35.3019 23.5455 35.3019ZM23.5455 36.4479C27.2796 36.4479 30.3068 33.4208 30.3068 29.6866C30.3068 25.9524 27.2796 22.9253 23.5455 22.9253C19.8113 22.9253 16.7842 25.9524 16.7842 29.6866C16.7842 33.4208 19.8113 36.4479 23.5455 36.4479Z",
    fill: "#1D254F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1529 35.3019C39.2542 35.3019 41.7682 32.7879 41.7682 29.6866C41.7682 26.5853 39.2542 24.0713 36.1529 24.0713C33.0516 24.0713 30.5376 26.5853 30.5376 29.6866C30.5376 32.7879 33.0516 35.3019 36.1529 35.3019ZM36.1529 36.4479C39.8871 36.4479 42.9142 33.4208 42.9142 29.6866C42.9142 25.9524 39.8871 22.9253 36.1529 22.9253C32.4187 22.9253 29.3916 25.9524 29.3916 29.6866C29.3916 33.4208 32.4187 36.4479 36.1529 36.4479Z",
    fill: "#1D254F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_50_3878",
    x: 9.40918,
    y: 32.3768,
    width: 43.8516,
    height: 41.2319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_3878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_3878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_50_3878",
    x: 6.81738,
    y: 10.7454,
    width: 46.9844,
    height: 46.2331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_3878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_3878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_50_3878",
    x: 24.8447,
    y: 14.6522,
    width: 10.4727,
    height: 10.7925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_3878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_3878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_50_3878",
    x: 6.6875,
    y: 28.4378,
    width: 34.0303,
    height: 28.3589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_3878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_3878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_3878",
    x1: 31.3377,
    y1: 37.3779,
    x2: 31.3374,
    y2: 62.6095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_3878",
    x1: 44.4311,
    y1: 40.5635,
    x2: 44.4311,
    y2: 53.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_50_3878",
    x1: 17.2065,
    y1: 41.7267,
    x2: 21.6495,
    y2: 32.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_50_3878",
    x1: 21.3721,
    y1: 28.1721,
    x2: 9.0218,
    y2: 28.1721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_50_3878",
    x1: 39.2432,
    y1: 28.1721,
    x2: 51.5934,
    y2: 28.1721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_50_3878",
    x1: 30.3095,
    y1: 45.9785,
    x2: 30.3095,
    y2: 15.7454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_50_3878",
    x1: 31.352,
    y1: 34.7535,
    x2: 17.3502,
    y2: 44.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.26f460e30f6f1f4300a60b23bbdca307.svg";
export { ForwardRef as ReactComponent };